// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Halogen_VDom_StringRenderer_Util from "../Halogen.VDom.StringRenderer.Util/index.js";
import * as Halogen_VDom_Types from "../Halogen.VDom.Types/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var NormalTag = /* #__PURE__ */ (function () {
    function NormalTag() {

    };
    NormalTag.value = new NormalTag();
    return NormalTag;
})();
var SelfClosingTag = /* #__PURE__ */ (function () {
    function SelfClosingTag() {

    };
    SelfClosingTag.value = new SelfClosingTag();
    return SelfClosingTag;
})();
var eqTagType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NormalTag && y instanceof NormalTag) {
                return true;
            };
            if (x instanceof SelfClosingTag && y instanceof SelfClosingTag) {
                return true;
            };
            return false;
        };
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(eqTagType);
var ordTagType = {
    compare: function (x) {
        return function (y) {
            if (x instanceof NormalTag && y instanceof NormalTag) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof NormalTag) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof NormalTag) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof SelfClosingTag && y instanceof SelfClosingTag) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Halogen.VDom.StringRenderer (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqTagType;
    }
};
var render = function (getTagType) {
    return function (renderAttrs) {
        return function (renderWidget) {
            var renderElement = function (maybeNamespace) {
                return function (v) {
                    return function (attrs) {
                        return function (children) {
                            var as = renderAttrs(attrs);
                            var as$prime = Data_Maybe.maybe(as)(function (v1) {
                                return "xmlns=\"" + (Halogen_VDom_StringRenderer_Util["escape"](v1) + ("\"" + (function () {
                                    var $19 = Data_String_Common["null"](as);
                                    if ($19) {
                                        return "";
                                    };
                                    return " " + as;
                                })()));
                            })(maybeNamespace);
                            return "<" + (v + ((function () {
                                var $20 = Data_String_Common["null"](as$prime);
                                if ($20) {
                                    return "";
                                };
                                return " ";
                            })() + (as$prime + (function () {
                                var $21 = Data_Array["null"](children);
                                if ($21) {
                                    var $22 = eq(getTagType(v))(SelfClosingTag.value);
                                    if ($22) {
                                        return "/>";
                                    };
                                    return "></" + (v + ">");
                                };
                                return ">" + (Data_String_Common.joinWith("")(map(go)(children)) + ("</" + (v + ">")));
                            })())));
                        };
                    };
                };
            };
            var go = function ($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v instanceof Halogen_VDom_Types.Text) {
                        $tco_done = true;
                        return Halogen_VDom_StringRenderer_Util["escape"](v.value0);
                    };
                    if (v instanceof Halogen_VDom_Types.Elem) {
                        $tco_done = true;
                        return renderElement(v.value0)(v.value1)(v.value2)(v.value3);
                    };
                    if (v instanceof Halogen_VDom_Types.Keyed) {
                        $tco_done = true;
                        return renderElement(v.value0)(v.value1)(v.value2)(map(Data_Tuple.snd)(v.value3));
                    };
                    if (v instanceof Halogen_VDom_Types.Widget) {
                        $tco_done = true;
                        return renderWidget(v.value0);
                    };
                    if (v instanceof Halogen_VDom_Types.Grafted) {
                        $copy_v = Halogen_VDom_Types.runGraft(v.value0);
                        return;
                    };
                    throw new Error("Failed pattern match at Halogen.VDom.StringRenderer (line 37, column 8 - line 42, column 32): " + [ v.constructor.name ]);
                };
                while (!$tco_done) {
                    $tco_result = $tco_loop($copy_v);
                };
                return $tco_result;
            };
            return go;
        };
    };
};
export {
    render,
    NormalTag,
    SelfClosingTag,
    eqTagType,
    ordTagType
};
